<template>
  <div class="container-fluid">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          :name="$t('modal.form.product.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{$t('modal.form.product.label')}}
            <v-select 
              v-model="form.product"
              :options="productsOptions"
            ></v-select>
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.quantity.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{$t('modal.form.quantity.label')}}
            <input 
              type="number"
              v-model="form.quantity"
              :placeholder="$t('modal.form.quantity.placeholder')"
            >
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.manager_id')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{$t('modal.form.manager_id')}}
            <v-select 
              v-model="form.manager"
              :options="managerOptions"
            ></v-select>
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.additional')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{$t('modal.form.additional')}}
            <textarea 
              v-model="form.additional"
              cols="30" 
              rows="5"
            ></textarea>
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <b-button
          class="float-end ms-3"
          variant="primary"
          type="submit"
          :disabled="db"
        >
          {{$t('modal.button.post')}}
        </b-button>

        <b-button
          class="float-end"
          variant="warning"
          @click="onClose"
        >
          {{$t('modal.button.back')}}
        </b-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  import {store} from '../../../../api/endpoints/driverManageIncomes'

  export default {
    name: "Driver-ManageIncomes",
    props: {
      productsOptions: {
        type: Array,
        required: true
      },
      managerOptions: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        form: {
          product: null,
          quantity: null,
          manager: null,
          additional: ""
        },
        db:false,
      }
    },
    methods: {
      onSubmit() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        store({
          product_id: this.form.product.value,
          quantity: this.form.quantity,
          manager_id: this.form.manager.value,
          additional: this.form.additional
        }).then( () => {
          this.onClose();
        })
      },
      onClose() {
        this.$emit('onClose')
      }
    }    
  }
</script>